<template>
  <div class="product-not-available">
    <Paragraph align="center">
      Leider ist das von Dir gesuchte Produkt nicht mehr verfügbar.
      <span v-if="hasOffers">
        <br />
        Wie wäre es mit folgenden Alternativen...
      </span>
    </Paragraph>
    <OfferTiles
      v-if="hasOffers"
      :offers="offers"
      class="product-not-available__offers"
    >
    </OfferTiles>
  </div>
</template>
<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue';
import { Paragraph } from '@i22/td-longtail-vue-components';
import fetchOffers from '@/lib/goliath/offers';
import OfferTiles from '~/components/offer-tiles-container.vue';
import {
  type ListQuery,
  type ListQueryVariables,
  OfferSortField,
  SortDirection,
} from '~/lib/goliath/goliath.types';

const props = defineProps({
  productSlug: {
    type: String,
    required: true,
  },
  numberOfResults: {
    type: Number,
    default: 4,
  },
});

// Define Refs
const offers = ref<NonNullable<NonNullable<ListQuery['offers']>['entries']>>([]);
const hasOffers = computed(() => offers.value.length > 0);

// Fetch Offers Function
const fetchOffersData = async () => {
  const search = props.productSlug
    .split('-')
    .filter((word) => word.length > 2 && Number.isNaN(Number(word))) // ignore short words and numbers
    .join('|');

  if (search === '') {
    offers.value = [];
    return;
  }

  const params: ListQueryVariables = {
    search,
    filter: {
      listed: true,
      productAvailable: true,
    },
    grouped: true,
    sort: { field: 'RELEVANCE' as OfferSortField, direction: 'ASC' as SortDirection },
    pagination: { size: props.numberOfResults },
    includeAggregations: false,
  };

  const data = await fetchOffers(params, false, true);
  if (!data) return;
  // @ts-ignore
  offers.value = data.entries;
};

// Fetch data when the component mounts
onMounted(fetchOffersData);
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.product-not-available {
  &__offers {
    margin-top: $grid-base * 2;

    @include mq($mq-sm) {
      margin-top: $grid-base * 4;
    }
  }
}
</style>
